// extracted by mini-css-extract-plugin
module.exports = {"main_page":"Indicators_main_page__3gnYM","main_header":"Indicators_main_header__afqnK","content":"Indicators_content__luLvP"};